import resourceData from "~/data/resource-data.json";
import get from "lodash.get";

/**
 * Injects a WordPress Page object into the resource listing
 * XHR data so we can use Yoast meta data, Modules, and other page
 * content features on listing pages.
 *
 * @param {Object} data Page XHR data
 * @param {String} type Resource type
 */
export const attachResourceListingPage = (data, type) => {
    const getPageKey = type => {
        switch (type) {
            case "resources":
                return "resources_page";
            case "library":
            case "ebooks":
            case "whitepapers":
                return "library_page";
            case "posts":
                return "blog_page";
            case "casestudies":
                return "case_studies_page";
            case "glossary":
                return "glossary_page";
            case "infographics":
                return "infographics_page";
            case "webinars":
                return "webinars_page";
            case "tools":
                return "tools_page";
            case "podcasts":
                return "podcasts_page";
            case "news":
                return "news_page";
            case "events":
                return "events_page";
            case "videos":
                return "videos_page";
            case "revenueexchange":
                return "revenue_exchange_page";
            default:
                return null;
        }
    };
    const key = getPageKey(type);

    if (key) data["listing_page"] = get(resourceData, `data.acf.${key}`);

    return data;
};
